exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// D:/Git/MSPC_CP/02_CloudServer/10_GIGAENERGY_Server/web/src/app/Component/chipsee-a9-systeminfo/chipsee-a9-systeminfo.component.css
// module id = ../../../../../src/app/Component/chipsee-a9-systeminfo/chipsee-a9-systeminfo.component.css
// module chunks = main